import { defineComponent as r } from "vue";
import n from "./component-library3.js";
import t from "./component-library5.js";
import s from "./component-library281.js";
const c = /* @__PURE__ */ r({
  __name: "gdpr-permission-layer",
  setup(p, { expose: o }) {
    const e = () => {
      window.utag?.gdpr?.showConsentPreferences && window.utag.gdpr.showConsentPreferences();
    };
    return o({ onSettingsReset: e }), { __sfc: !0, onSettingsReset: e, LinkButton: n, Paragraph: t, NoAccessIcon: s };
  }
});
export {
  c as default
};
